<div class="modal-header">
    <span *ngIf="!departmentId" class="modal-header-title">{{ 'EMPLOEE.ADD_DEPARTMENT' | translate }}</span>
    <span *ngIf="departmentId"  class="modal-header-title">{{ 'EMPLOEE.EDIT_DEPARTMENT' | translate }}</span>
    <div class="tool">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12">
                <ff-input-lang
                    label="{{ 'EMPLOEE.DEPARTMENT_TITLE' | translate }}"
                    hint="{{ 'EMPLOEE.DEPARTMENT_TITLE_ALL_LANGUAGE' | translate }}"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="departmentName" 
                    (changeValue)="eventFnFF('name', $event.name)">
                </ff-input-lang>
            </div>

            <div class="col-12">
                <div class="form-group">
                    <label for="department"> {{ 'EMPLOEE.DEPARTMENT' | translate }}</label>
                    <ng-select  
                        id="department"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="parent_id"
                        [loading]="loading"
                        [items]="departmentsReference"
                        >
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.department">
                            <div class="text-error" *ngIf="validation('department_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>   

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button *ngIf="!departmentId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="departmentId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>